import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(0, 2),
    textAlign: "center",
  },
  link: {
    display: "inline-flex",
    color: theme.palette.text.primary,
    padding: theme.spacing(1.5, 0.5),
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Link
        target="_blank"
        rel="noopener"
        href="https://gofreem.de/datenschutz"
        underline="always"
        className={classes.link}
      >
        Datenschutz
      </Link>
      <span>|</span>
      <Link
        target="_blank"
        rel="noopener"
        href="https://gofreem.de/nutzungsbedingungen"
        underline="always"
        className={classes.link}
      >
        Nutzungsbedingungen
      </Link>
    </footer>
  );
};

export default Footer;
